const cacheDaysBetweenDates = {};
const utilsConfig = {
  divisionToDaysBetween: 1000 * 60 * 60 * 24,
};

/**
 * Retorna formato para una fecha, por ejemplo:
 *
 * Hoy 20:00
 * Ayer 20:00
 * Fecha completa
 */
export const formatDate = (dateValue: string, dateFrom: Date): string => {
  if (!dateValue) return dateValue;
  const dateFromCache = getDateWhitoutHours(dateFrom);
  const dateTo = new Date(dateValue);
  const dateToCache = getDateWhitoutHours(dateTo);

  let daysBetweenn = null;

  if (
    typeof cacheDaysBetweenDates[`${dateToCache}_${dateFromCache}`] !==
    "undefined"
  ) {
    daysBetweenn = cacheDaysBetweenDates[`${dateToCache}_${dateFromCache}`];
  } else {
    daysBetweenn = getDaysBetweenDates(dateFrom, dateTo);
    cacheDaysBetweenDates[`${dateToCache}_${dateFromCache}`] = daysBetweenn;
  }

  let dateResponse = "";

  if (daysBetweenn === 0) {
    const hourTime = dateValue.split(" ")[1];
    dateResponse = `Hoy ${hourTime}`;
  } else if (daysBetweenn === 1) {
    const hourTime = dateValue.split(" ")[1];
    dateResponse = `Ayer ${hourTime}`;
  } else {
    dateResponse = dateValue;
  }

  return dateResponse;
};

export const getDaysBetweenDates = (dateFrom: Date, dateTo: Date) => {
  const timeFrom = dateFrom.getTime();
  const timeTo = dateTo.getTime();
  const daysBetweenn =
    Math.abs(timeTo - timeFrom) / utilsConfig.divisionToDaysBetween;

  return parseInt(`${daysBetweenn}`);
};

export const getDateWhitoutHours = (date: Date) => {
  const month = dateValueToStr(date.getMonth() + 1);
  const day = dateValueToStr(date.getDate());

  return `${date.getFullYear()}-${month}-${day}`;
};

export const dateValueToStr = (value: number) => {
  if (value >= 10) {
    return `${value}`;
  }
  return `0${value}`;
};
